import { pushEventToDataLayer } from "seneca-common/features/analytics/gtm";

const namespace = "seneca/user/signup";

export function logStudentAddsGuardianEmailOnSignup() {
  return pushEventToDataLayer({
    event: `${namespace}/addGuardianEmail`
  });
}

export function logConfirmNameOnSignUp() {
  return pushEventToDataLayer({
    event: `${namespace}/confirmName`
  });
}
